

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
  
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }

    };
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: [],


    });
    $('.box').boxWidget();

    //this.consultar();

  },

  computed: {
    reporte: function () {
      return (
        "/reportes/resumen/banconvo?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/resumen/banconvo', this.f_c)
        .then(response => {

          if (response.data.status == 1) {
            response.data.data.forEach(r => {
              r[6] = this.num_to_many(r[6]);
              this.tbv.row.add(r);
            });
          } 
          this.tbv.draw();
          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/reportes/bancoForconi/tventas/tventas.js